module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraLightItalic.2a23ba1a.woff";